import request from '#/utils/request';
import { parseVer4DetailResponse, parseVer4TreeResponse } from '#/api/adapters/envelope';
import {
  serializeWorkOrderRepairCorrection,
  serializeWorkOrderRepairCreate,
  serializeWorkOrderRepairUpdate,
  serializeWorkOrderRepairVersion,
} from '#/api/momMgmt/workOrderRepair/serialize';

/** POST `/mom/work-order-repair` → 201（工單須 PROCESSING／CLOSED／ABORTED）。 */
export async function createWorkOrderRepair(values) {
  const { data: raw } = await request.post(
    '/mom/work-order-repair',
    serializeWorkOrderRepairCreate(values),
  );
  return parseVer4DetailResponse(raw);
}

/** PATCH `/mom/work-order-repair/{id}`（僅 OPEN）。 */
export async function updateWorkOrderRepair(id, values) {
  const { data: raw } = await request.patch(
    `/mom/work-order-repair/${id}`,
    serializeWorkOrderRepairUpdate(values),
  );
  return parseVer4DetailResponse(raw);
}

/** POST `/mom/work-order-repair/{id}/close`：數量須平衡；同交易扣用料庫存。 */
export async function closeWorkOrderRepair(id, values) {
  const { data: raw } = await request.post(
    `/mom/work-order-repair/${id}/close`,
    serializeWorkOrderRepairVersion(values),
  );
  return parseVer4DetailResponse(raw);
}

/** GET `/mom/work-order-repair/{id}/corrections`（created_at DESC）。 */
export async function fetchWorkOrderRepairCorrections(id) {
  const { data: raw } = await request.get(`/mom/work-order-repair/${id}/corrections`);
  return parseVer4TreeResponse(raw);
}

/**
 * POST `/mom/work-order-repair/{id}/corrections` → 201，立即過帳沖回所選用料。
 * `idempotencyKey`：同一次操作重送用同一把（≤128 字、不可 `system:` 開頭）。
 */
export async function createWorkOrderRepairCorrection(id, values, { idempotencyKey }) {
  const { data: raw } = await request.post(
    `/mom/work-order-repair/${id}/corrections`,
    serializeWorkOrderRepairCorrection(values),
    { headers: { 'Idempotency-Key': idempotencyKey } },
  );
  return parseVer4DetailResponse(raw);
}
